import { useState } from "react"
import { useSelector } from "react-redux"
import * as Paymethods from '../../../../../../../utils/paymethods'
import {
    checkout_credit,
    stripeCallBack,
    openSafeChargeOrder,
    setSafeCharge,
    canOrderPay
} from '../../../../../../../api'
import { loadStripe } from '@stripe/stripe-js'
import { useApp } from "../../../../../../hooks/common"
import {
    appendSafeChargeScript
} from '../utils/safecharge'
import getPublicKey from "../../../../../../utils/get-public-key"

export default props => {
    const global = useSelector(state => state.global)
    const {
        config
    } = global
    const isApp = useApp()
    const [paying, setPaying] = useState(false)
    const pageCart = useSelector(state => state.pageCart)
    const { creditOrder: storedOrder, cardList } = pageCart

    const canPay = async () => {
        const response = await canOrderPay(storedOrder?.order?.id)
        if(response?.code === 200){
            return !!response?.result
        }
        return true
    }

    const pay = async (params, openedOrder)  => {
        setPaying(true)
        const selectedCard = cardList?.find?.(c => c.isSelected)
        const creditOrder = openedOrder || storedOrder

        if (selectedCard) {
            const { quickpayRecord } = selectedCard
            const payMethod = quickpayRecord?.payMethod
            let response
            switch (payMethod) {
                case Paymethods.__Pay_Method_Stripe__:
                case Paymethods.__Pay_Method_Stripe_EU__:
                case Paymethods.__Pay_Method_Stripe_GB__:
                case Paymethods.__Pay_Method_Stripe_IR__:
                    response = await checkout_credit({
                        payMethod,
                        orderId: creditOrder?.order?.id
                    })

                    if (response?.code === 200 && response?.result) {
                        const { key, transactionId, orderId, success, details } = response.result
                        if (!success && key) {
                            const stripe = await loadStripe(getPublicKey(config?.paykeys?.stripe?.publicKey, payMethod))
                            const payload = await stripe.confirmCardPayment(key)
                            if (payload) {
                                await stripeCallBack({
                                    ...payload,
                                    orderId,
                                    transactionId,
                                    payMethod
                                })

                                if (payload.error) {
                                    props?.onError({
                                        message: payload.error?.message || 'Network Error',
                                        orderId,
                                        type: 'go_unpaid',
                                    })
                                } else {
                                    window.location.href = `/order-confirm/${transactionId}?transactionId=${transactionId}`
                                }
                            }
                        }else if(success){
                            window.location.href = `/order-confirm/${transactionId}?transactionId=${transactionId}`
                        }else if(details){
                            props?.onError({
                                message: details || 'Network Error',
                                orderId,
                                type: 'go_unpaid',
                            })
                        }
                    } else {
                        props?.onError({
                            message: response?.result || 'Network Error',
                            orderId: creditOrder?.order?.id,
                            type: 'go_unpaid',
                        })
                    }
                    setPaying(false)
                    break
                case Paymethods.__Pay_Method_SafeCharge__:

                    let openSafechargeResponse = await openSafeChargeOrder({
                        orderId: creditOrder?.order?.id,
                        payMethod
                    })

                    if (openSafechargeResponse?.code === 200 && openSafechargeResponse?.result) {
                        const {
                            openOrderResponse,
                            email,
                            country,
                            ip,
                            billingAddress,
                        } = openSafechargeResponse?.result

                        const safechargeOrder = openOrderResponse
                        const SafeCharge = await appendSafeChargeScript()
                        const safecharge = SafeCharge({
                            env: config?.env === 'sandbox' ? 'test' : 'prod',
                            merchantId: safechargeOrder?.merchantId,
                            merchantSiteId: safechargeOrder?.merchantSiteId
                        })

                        safecharge.createPayment({
                            'sessionToken': safechargeOrder?.sessionToken,
                            'merchantId': safechargeOrder?.merchantId,
                            'merchantSiteId': safechargeOrder?.merchantSiteId,
                            'clientUniqueId': safechargeOrder?.clientUniqueId, // optional
                            'userTokenId': safechargeOrder?.userTokenId,
                            'paymentOption': {
                                'userPaymentOptionId': selectedCard?.quickpayRecord?.quickpayId,
                            },
                            'billingAddress': billingAddress,
                            'deviceDetails': {
                                'ipAddress': ip
                            }
                        }, async res => {
                            const { orderId, transactionId } = creditOrder?.order
                            if (res.result === 'APPROVED') {
                                const setResponse = await setSafeCharge({ ...res, transactionId, sessionToken: safechargeOrder?.sessionToken })
                                if (setResponse?.code === 200 && setResponse?.result) {
                                    const { clientUniqueId } = setResponse?.result
                                    window.location.href = `/order-confirm/${clientUniqueId}?transactionId=${clientUniqueId}`
                                } else {
                                    props?.onError({
                                        message: setResponse?.result || 'Network Error',
                                        type: 'go_unpaid',
                                        orderId
                                    })
                                }
                            } else {
                                props.onError({
                                    message: res.errorDescription || res.reason || 'Network Error',
                                    type: 'go_unpaid',
                                    orderId
                                })
                            }
                            setPaying(false)
                        })
                    } else {
                        props?.onError({
                            message: response?.result || 'Network Error'
                        })
                    }
                    setPaying(false)
                    break

                default:   
                    response = await checkout_credit({
                        payMethod,
                        orderId: creditOrder?.order?.id,
                        ...(params || {})
                    })

                    if(response?.code === 200 && response?.result){
                        const { transactionId, orderId, success, noticeType, redirect, details } = response?.result
                        if(success){
                            window.location.href = redirect || `/order-confirm/${transactionId}?transactionId=${transactionId}`
                        }else{
                            props?.onError?.({
                                message: details || 'Network Error',
                                noticeType
                            })
                        }
                    }else{
                        props?.onError({
                            message: response?.result || 'Network Error'
                        })
                    }
                    setPaying(false)
                    break
            }

        }
    }

    return {
        paying,
        pay,
        canPay
    }
}